import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * XP to test the impact of fetching the cart client side
 */
export const FE_PDP_FETCH_CART_CLIENT_SIDE_250612 = experiment({
  name: "FE_PDP_FETCH_CART_CLIENT_SIDE_250612",
  identifier: "RetailerTokenInSession",
  client: ["RETAILER", "RETAILER_HEAD_TAGS"],
  notifyAfter: "2025-06-30",
  defaultValue: false,
  productArea: "PRODUCT_PAGE",
});
